import { render, staticRenderFns } from "./UpdateOrderTip.vue?vue&type=template&id=28272454&scoped=true"
import script from "./UpdateOrderTip.vue?vue&type=script&lang=js"
export * from "./UpdateOrderTip.vue?vue&type=script&lang=js"
import style0 from "./UpdateOrderTip.vue?vue&type=style&index=0&id=28272454&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28272454",
  null
  
)

export default component.exports